import {InfiniteData, MailFoldersResponseType, useClientAccountOverview, UseQueryResult} from "@twigsby/client-data";
import {AccountOverviewType} from "@twigsby/client-data/lib/Types/AccountOverviewTypes";
import {
    ContentBlock,
    ContentLoader,
    NavigationEntryType,
    SectionNavigation,
    useLayout
} from "@twigsby/frontend-framework";
import React, {ForwardedRef, forwardRef, useCallback, useEffect, useState} from 'react';
import {useTranslation} from "@twigsby/frontend-framework";
import {useMailbox} from "../../Providers/NewMailboxProvider";
import MailboxFolders from "./MailboxFolders";

export interface MailboxNavigationInterface {
    title: string;
    createFolderSuccessCallback?: any;
    addonContent?: any;
}

const ShapeMenuData = (data: InfiniteData<MailFoldersResponseType> | undefined, accountOverviewData: UseQueryResult<AccountOverviewType>) => {
    let selectOptions: Array<NavigationEntryType> = [];

    if(!data) return selectOptions;

    data.pages.map((page) =>
        page.data.map((item, index: number) => {
            selectOptions.push(
                {
                    title: item.name,
                    badgeCount: item.id === 9 && accountOverviewData?.data?.counts ? accountOverviewData?.data?.counts?.lockedMailCount : 0,
                    path: `../mail/${item.name.replace(' ', '-').toLowerCase()}`,
                    state: (item.id === 8 || item.id === 9) ? { includeFolderAssigned: true } : undefined
                }
            )
        })
    )

    return selectOptions;
}

const MailboxNavigation = forwardRef((props: MailboxNavigationInterface, ref: ForwardedRef<HTMLDivElement>) => {
    const { t } = useTranslation();
    const { isLarge } = useLayout();
    const { folderData, folderError, folderStatus } = useMailbox();

    const accountOverviewData = useClientAccountOverview();

    const [ mailMenuData, setMailMenuData] = useState<Array<NavigationEntryType>>(ShapeMenuData(folderData, accountOverviewData));

    const UpdateMenuData = useCallback(() => {
        if(accountOverviewData && folderData) {
            setMailMenuData(ShapeMenuData(folderData, accountOverviewData));
        }
    }, [folderData, accountOverviewData]);

    useEffect(() => {
        if(folderData && folderStatus === 'success' && mailMenuData.length === 0) {
            UpdateMenuData();
        }
    }, [folderData]);

    useEffect(() => {
        if(accountOverviewData.status === 'success') {
            UpdateMenuData();
        }
    }, [accountOverviewData.dataUpdatedAt]);

    return (
        <>
            {(folderStatus === "loading" || accountOverviewData.status === 'loading') ? (
                <>
                    <div className={'p-sm'}>
                        <ContentLoader childHeight={'3em'} rounded={true} childCount={1} />
                    </div>
                    <div className={'p-sm mt-n-sm'}>
                        <ContentLoader childHeight={'3em'} rounded={true} />
                    </div>
                </>
            ) : folderStatus === "error" ? (
                <ContentBlock error={true} title={folderError?.name as string} content={folderError?.message} extraClass={'m-md'} />
            ) : (
                <SectionNavigation ref={ref} title={isLarge ? t('mailboxes.navigation.title') : props.title} entries={mailMenuData} rounded={true} addonContent={props.addonContent}>
                    <MailboxFolders />
                </SectionNavigation>
            )}
        </>
    );
});

export default MailboxNavigation;
